import React, { useState, useEffect } from 'react';
import './Slideshow.css';

const images = [
  process.env.PUBLIC_URL + "/images/slideshow1.jpeg",
  process.env.PUBLIC_URL + "/images/slideshow2.jpeg",
  process.env.PUBLIC_URL + "/images/slideshow3.jpeg",
  process.env.PUBLIC_URL + "/images/slideshow4.jpeg",

];

const Slideshow = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fadeClass, setFadeClass] = useState('fade-in');

  useEffect(() => {
    const interval = setInterval(() => {
      setFadeClass('fade-out');
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % images.length);
        setFadeClass('fade-in');
      }, 500);
    }, 15000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="slideshow-section">
      <div className="slideshow">
        <img
          src={images[currentIndex]}
          alt={`Slide ${currentIndex + 1}`}
          className={`slideshow-image ${fadeClass}`}
        />
      </div>
    </div>
  );
};

export default Slideshow;


